// Arkusz „stroik": nuta z mikrofonu, odchyłka w centach i najbliższa struna.
// Własny strumień mikrofonu, zamykany razem z arkuszem. Liczenie wysokości
// żyje w `audio/wysokosc.ts`, tu jest tylko Web Audio i wyświetlanie.

import { autokorelacja, najblizszaStruna, nutaZCzestotliwosci, STRUNY_STANDARD } from '../audio/wysokosc.ts';
import { dodajGotowe, otworzArkusz } from './arkusz.ts';

const ROZMIAR_OKNA = 2048;
const INTERWAL_MS = 90;
/** W tej odchyłce struna jest „nastrojona". */
const TOLERANCJA_CENTOW = 5;

export function otworzStroik(): void {
  let sprzatnij: (() => void) | null = null;
  const arkusz = otworzArkusz('stroik', () => sprzatnij?.());

  const tarcza = document.createElement('div');
  tarcza.className = 'og-stroik';
  tarcza.innerHTML =
      '<div class="og-stroik-nuta">–</div>'
    + '<div class="og-stroik-skala"><span class="og-stroik-srodek"></span><span class="og-stroik-wskazowka"></span></div>'
    + '<div class="og-stroik-opis">zagraj jedną strunę</div>'
    + `<div class="og-stroik-struny">${STRUNY_STANDARD.map((s) => `<span>${s.nazwa}</span>`).join('')}</div>`;
  arkusz.karta.appendChild(tarcza);
  dodajGotowe(arkusz);

  const nuta = tarcza.querySelector<HTMLElement>('.og-stroik-nuta')!;
  const wskazowka = tarcza.querySelector<HTMLElement>('.og-stroik-wskazowka')!;
  const opis = tarcza.querySelector<HTMLElement>('.og-stroik-opis')!;
  const struny = [...tarcza.querySelectorAll<HTMLElement>('.og-stroik-struny span')];

  void (async () => {
    let strumien: MediaStream | null = null;
    let kontekst: AudioContext | null = null;
    let id: ReturnType<typeof setInterval> | null = null;
    sprzatnij = () => {
      if (id !== null) clearInterval(id);
      strumien?.getTracks().forEach((t) => t.stop());
      if (kontekst && kontekst.state !== 'closed') void kontekst.close();
      id = null; strumien = null; kontekst = null;
    };
    try {
      strumien = await navigator.mediaDevices.getUserMedia({
        // Bez przetwarzania mowy: tłumienie szumu i automatyczne wzmocnienie
        // zniekształcają pojedynczy ton struny.
        audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false },
      });
      if (!arkusz.otwarty()) { sprzatnij(); return; }
      kontekst = new AudioContext();
      const analizator = kontekst.createAnalyser();
      analizator.fftSize = ROZMIAR_OKNA;
      kontekst.createMediaStreamSource(strumien).connect(analizator);
      const bufor = new Float32Array(ROZMIAR_OKNA);
      const sr = kontekst.sampleRate;

      id = setInterval(() => {
        if (!arkusz.otwarty()) { sprzatnij?.(); return; }
        analizator.getFloatTimeDomainData(bufor);
        const hz = autokorelacja(bufor, sr);
        // Poza zakresem gitary (i poza sensem pomiaru) nie pokazujemy nic,
        // zamiast skakać po przypadkowych nutach.
        if (hz < 60 || hz > 1200) { tarcza.classList.remove('og-stroik--aktywny'); return; }
        tarcza.classList.add('og-stroik--aktywny');
        const n = nutaZCzestotliwosci(hz);
        const s = najblizszaStruna(hz);
        nuta.textContent = n.nazwa;
        const centy = Math.max(-50, Math.min(50, n.centy));
        wskazowka.style.left = `${50 + centy}%`;
        const trafiona = Math.abs(n.centy) <= TOLERANCJA_CENTOW;
        tarcza.classList.toggle('og-stroik--trafiona', trafiona);
        opis.textContent = trafiona ? 'czysto' : `${n.centy > 0 ? '+' : ''}${n.centy} ct · ${n.centy > 0 ? 'popuść' : 'dokręć'}`;
        struny.forEach((el, i) => el.classList.toggle('og-stroik-struna--blisko', i === s.indeks));
      }, INTERWAL_MS);
    } catch {
      sprzatnij();
      opis.textContent = 'brak dostępu do mikrofonu';
    }
  })();
}
